// All needed imports
import { Component } from '@angular/core';

@Component({
  selector: 'app-error404',
  templateUrl: './error404.component.html',
  styleUrls: [ './error404.component.scss' ]
})
// Error404 component declaration
export class Error404Component {
}
